//react
import React, { useMemo } from "react";
import { DataTable, SelectColumnFilter } from "./DataTable";

import { format } from "date-fns";

const defaultSortBy = [
  {
    id: "enteredOn",
    desc: true,
  },
];

const DeliveryConcernTable = ({
  deliveryConcerns,
  onDetailsClick,
  isLoading,
  isError,
}) => {
  const tableColumns = React.useMemo(
    () => [
      {
        Header: "Incident No.",
        accessor: "tranId",
        // disableSortBy: true,
        width: 100,
      },
      {
        Header: "Delivery ID",
        accessor: "deliveryId",
        width: 120,
      },
      {
        Header: "Invoice",
        accessor: "invoiceNumber",
        // sortType: alphaNumericCaseInsensitiveSortFunction,
        width: 130,
      },

      {
        Header: "Entered On",
        accessor: "enteredOn",
        disableFilters: true,
        sortType: "datetime",
        Cell: ({ value }) => format(value, "MM/dd/yyyy"),
      },
      {
        Header: "Route",
        accessor: "route",
        // disableSortBy: true,
        // sortType: alphaNumericCaseInsensitiveSortFunction,
      },
      {
        Header: "Customer/City",
        accessor: "customerCity",
        // disableSortBy: true,
        // sortType: alphaNumericCaseInsensitiveSortFunction,
        width: 250,
      },
      {
        Header: "Shipping Date",
        accessor: "shippingDate",
        disableFilters: true,
        sortType: "datetime",
        Cell: ({ value }) => format(value, "MM/dd/yyyy"),
      },
      {
        Header: "Status",
        accessor: "status",
        disableSortBy: true,
        Filter: SelectColumnFilter,
        // filter: "equals",
      },
      {
        Header: "Options",
        accessor: "deliveryConcernMenu",
        Cell: ({ value }) => (
          <button
            className="btn btn-primary"
            onClick={(e) => {
              e.preventDefault();
              onDetailsClick(value);
            }}
          >
            Details
          </button>
        ),
        disableFilters: true,
        disableSortBy: true,
        width: 90, //why does any lower than 86 look weird on smaller devices? the header doesnt go all the way to the right of the table, at first i thought it was cause of button but button is only 74px, order history table seems to be fine?
      },
    ],
    []
  );

  const tableData = useMemo(
    () =>
      deliveryConcerns.map((dc) => ({
        deliveryId: dc.deliveryId,
        invoiceNumber: dc.invoiceNumber,
        tranId: dc.tranId,
        enteredOn: new Date(dc.tDate),
        route: dc.route,
        customerCity: dc.customerCity,
        shippingDate: new Date(dc.shippingDate),
        status: dc.status,
        deliveryConcernMenu: dc.tranId,
      })),
    [deliveryConcerns]
  );

  return (
    <DataTable
      columns={tableColumns}
      data={tableData}
      isError={isError}
      isLoading={isLoading}
      slotProps={{ topToolbar: { disabled: true } }}
      initialState={{
        sortBy: defaultSortBy,
      }}
    />
  );
};

export default DeliveryConcernTable;
